import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Card, Collapse } from 'reactstrap';
import { CommonStore } from '../stores/commonStore';

@observer
class TermsOfUse extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = { collapse: false };
  }

  toggle() {
    const { collapse } = this.state;
    this.setState({ collapse: !collapse });
  }

  render() {
      const { commonStore } = this.props;
      const { termsOfUse } = commonStore;
      const showTermsOfUse = termsOfUse.showBlock;
      if (showTermsOfUse) {
          const { commonStore } = this.props;
          const { termsOfUse } = commonStore;
          const { collapse } = this.state;
          const btnStyles = {
              border: 'none',
              backgroundColor: '#e8ebeb',
              outline: 'none',
              fontWeight: '500',
          };

          return (
              <div className="section">
                <div className="card card-collapsible">
                  <h5 className="card-header">
                    <button
                        type="button"
                        className={`card-collapsible-link ${!collapse ? 'collapsed' : ''}`}
                        style={btnStyles}
                        onClick={this.toggle}
                        onKeyUp={this.toggle}
                    >
                      Terms of use
                    </button>
                  </h5>
                </div>
                <Collapse isOpen={collapse}>
                  <Card>
                    <div>
                      <section style={{ padding: '10px', textAlign: 'justify' }} className="agreement">
                        <div dangerouslySetInnerHTML={{__html: termsOfUse.content}}/>
                      </section>
                    </div>
                  </Card>
                </Collapse>
              </div>
          );
      }
      return null;
  }
}

export default TermsOfUse;

TermsOfUse.propTypes = {
  commonStore: PropTypes.instanceOf(CommonStore).isRequired,
};
